import { render, staticRenderFns } from "./AgentsStatistics.vue?vue&type=template&id=05f80b11&scoped=true&"
import script from "./AgentsStatistics.vue?vue&type=script&lang=js&"
export * from "./AgentsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AgentsStatistics.vue?vue&type=style&index=0&id=05f80b11&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f80b11",
  null
  
)

export default component.exports